import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { inject as service } from "@ember/service"
import type ModalManager from "cc-frontend/services/modal-manager"
import styles from "./weekly-order.module.css"

@tagName("")
export default class WeeklyOrderModalComponent extends Component {
  readonly styles = styles
  isSmall = false

  @service modalManager!: ModalManager
}
